const SAVE_POSTING_DB = 'publicador/savePosting/SAVE_POSTING_DB';
const SAVE_POSTING_DB_COMPLETED = 'publicador/savePosting/SAVE_POSTING_DB_COMPLETED';
const SAVE_POSTING_DB_FAILED = 'publicador/savePosting/SAVE_POSTING_DB_FAILED';
const SAVE_POSTING_DB_CLEAR_ERROR = 'publicador/savePosting/SAVE_POSTING_DB_CLEAR_ERROR';

export { SAVE_POSTING_DB, SAVE_POSTING_DB_COMPLETED, SAVE_POSTING_DB_FAILED, SAVE_POSTING_DB_CLEAR_ERROR };
